import {colors} from "./theme";

const Divider = () => {
  return (
    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
      <div style={{
        // paddingTop: '40px',
        height: '3px',
        backgroundImage: `linear-gradient(to right, transparent, ${colors.primaryGold}, transparent)`,
        // margin: 'auto 10%'
      }} />
    </div>
  );
};

export default Divider;
